import { CalculationResultDto } from "../models/calculation-api.types";
import { CalculationResult } from "../models/CalculationResult";

export function calculationResultMapper(
  result: CalculationResultDto
): CalculationResult {
  return {
    totalAmount: result.result.totalAmount,
    children: result.result.children.map((child) => ({
      name: child.name,
      totalAmount: child.totalAmount,
      breakdown: child.breakdown.map((item) => ({
        type: item.type,
        amount: item.amount,
      })),
    })),
  };
}
